// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSEmphasizeText/index.less
// module id = 960
// module chunks = 42